import { Box, Typography } from '@mui/material'
import React from 'react'

export default function CustomHeading({ lable, onClick}) {
  return (
   <>
   <Box sx={{display:"inline-flex" , alignItems:"center", gap:2, cursor:"pointer"}}>
    <Box width={32} onClick={onClick}>
          <img src="/newdashboard/Classrom/wishlist.png" alt="Back" />
        </Box>
        <Typography
          fontFamily="Inter"
          fontWeight={400}
          color="#000"
          fontSize="24px"
        >
        {lable}
        </Typography>
        </Box>
   </>
  )
}
